/**
 * ロケールリンク修正
 * 現在のロケール（/en）を全リンクで維持
 */

(function() {
  'use strict';

  // 現在のロケールを検出
  const currentPath = window.location.pathname;
  const isEnglish = currentPath.startsWith('/en');
  
  if (!isEnglish) {
    // 日本語ページでは何もしない
    return;
  }

  console.log('[Locale Links] 英語モード検出 - 全リンクに/enプレフィックスを追加');

  // すべての内部リンクを修正
  function fixLinks() {
    const links = document.querySelectorAll('a[href^="/"]');
    let fixedCount = 0;

    links.forEach(link => {
      const href = link.getAttribute('href');

      // 既に /en で始まっている場合はスキップ
      if (href.startsWith('/en')) {
        return;
      }

      // data-no-locale-fix 属性がある場合はスキップ（言語切り替えリンク等）
      if (link.hasAttribute('data-no-locale-fix')) {
        return;
      }

      // /en プレフィックスを追加
      const newHref = '/en' + href;
      link.setAttribute('href', newHref);
      fixedCount++;
    });

    if (fixedCount > 0) {
      console.log(`[Locale Links] ${fixedCount}個のリンクを修正`);
    }
  }

  // DOM読み込み完了後に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixLinks);
  } else {
    fixLinks();
  }

  // 動的に追加されるリンクにも対応（MutationObserver）
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          // 追加されたノード内のリンクを修正
          if (node.tagName === 'A' && node.getAttribute('href')?.startsWith('/')) {
            const href = node.getAttribute('href');
            if (!href.startsWith('/en') && !node.hasAttribute('data-no-locale-fix')) {
              node.setAttribute('href', '/en' + href);
            }
          }

          // 子孫のリンクも修正
          const childLinks = node.querySelectorAll('a[href^="/"]');
          childLinks.forEach(link => {
            const href = link.getAttribute('href');
            if (!href.startsWith('/en') && !link.hasAttribute('data-no-locale-fix')) {
              link.setAttribute('href', '/en' + href);
            }
          });
        }
      });
    });
  });

  // body全体を監視
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  console.log('[Locale Links] 動的リンク監視開始');
})();
